import React from "react";

const InputField = ({ field, value, onChange }) => {
  return (
    <div key={field.key} className="mb-4 sm:mb-5">
      <label className="block text-gray-700 font-medium mb-2 text-sm sm:text-base">
        {field.label}
        {field.required && <span className="text-red-500 ml-1">*</span>}
      </label>
      {field.type === "textarea" ? (
        <textarea
          value={value}
          onChange={(e) => onChange(field.key, e.target.value)}
          placeholder={field.placeholder}
          rows={field.key === "address" ? 3 : 4}
          className="w-full p-3 sm:p-4 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none transition-all duration-200 hover:border-gray-400 text-sm sm:text-base min-h-[100px] touch-manipulation"
        />
      ) : (
        <input
          type={field.type}
          value={value}
          onChange={(e) => onChange(field.key, e.target.value)}
          placeholder={field.placeholder}
          className="w-full p-3 sm:p-4 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 hover:border-gray-400 text-sm sm:text-base min-h-[48px] touch-manipulation"
        />
      )}
    </div>
  );
};

export default InputField;
